import ContactCard from "@/components/shared-ui/ContactCard";
import * as Styled from "./styled";
import Card from "@/components/shared-ui/Card";
import Page from "@/components/layout/Page";
import { useQuery } from "@tanstack/react-query";
import useApi from "@/contexts/ApiContext";
import LoadingScreen from "@/components/shared-ui/LoadingScreen";

const AccountManagement = () => {
  const api = useApi();
  const { data: accountManagementData } = useQuery({
    queryKey: ["get-company-management"],
    queryFn: () => api.company.getManagementStructure(),
  });

  if (!accountManagementData) {
    return <LoadingScreen />;
  }

  return (
    <Page title="Account management">
      <Styled.AccountManagement>
        {accountManagementData && (
          <Card>
            <Styled.PageHeading>
              Account management structure
            </Styled.PageHeading>
            <Styled.ServiceSummaryContent>
              {accountManagementData.firm_status && (
                <>
                  <Styled.Detail>Status:</Styled.Detail>
                  <Styled.HighlightedFieldValue isStatus>
                    {accountManagementData.firm_status}
                  </Styled.HighlightedFieldValue>
                </>
              )}
              {accountManagementData.owner && (
                <>
                  <Styled.Detail>Account manager:</Styled.Detail>
                  <Styled.FieldValuesWrapper>
                    <span>
                      {accountManagementData.owner.name}
                      <br />
                      {accountManagementData.owner.email}
                    </span>
                  </Styled.FieldValuesWrapper>
                </>
              )}
              {accountManagementData.partner_launch_executive.length > 0 && (
                <>
                  <Styled.Detail>
                    {accountManagementData.partner_launch_executive.length > 1
                      ? "Launch managers:"
                      : "Launch manager:"}
                  </Styled.Detail>
                  <Styled.FieldValuesWrapper>
                    {accountManagementData.partner_launch_executive.map(
                      (manager) => (
                        <span key={manager.email}>
                          {manager.name}
                          <br />
                          {manager.email}
                        </span>
                      ),
                    )}
                  </Styled.FieldValuesWrapper>
                </>
              )}
              {accountManagementData.customer_success_executive && (
                <>
                  <Styled.Detail>Customer support manager:</Styled.Detail>
                  <Styled.FieldValuesWrapper>
                    <span>
                      {accountManagementData.customer_success_executive.name}
                      <br />
                      {accountManagementData.customer_success_executive.email}
                    </span>
                  </Styled.FieldValuesWrapper>
                </>
              )}
              {accountManagementData.strategic_account_director && (
                <>
                  <Styled.Detail>Strategic account director:</Styled.Detail>
                  <Styled.FieldValuesWrapper>
                    <span>
                      {accountManagementData.strategic_account_director.name}
                      <br />
                      {accountManagementData.strategic_account_director.email}
                    </span>
                  </Styled.FieldValuesWrapper>
                </>
              )}
              {accountManagementData.ch_escalation_points.length > 0 && (
                <>
                  <Styled.Detail>
                    {accountManagementData.ch_escalation_points.length > 1
                      ? "Escalation points:"
                      : "Escalation point:"}
                  </Styled.Detail>
                  <Styled.FieldValuesWrapper>
                    {accountManagementData.ch_escalation_points.map((point) => (
                      <span key={`${point.email}-${point.name}`}>
                        {point.name}, {point.job_title}
                        <br />
                        {point.email}
                        <br />
                        {point.phone_number}
                      </span>
                    ))}
                  </Styled.FieldValuesWrapper>
                </>
              )}
              {accountManagementData.meeting_cadence && (
                <>
                  <Styled.Detail>Meetings:</Styled.Detail>
                  <Styled.FieldValuesWrapper>
                    {accountManagementData.meeting_cadence.map((v) => (
                      <Styled.HighlightedFieldValue key={v}>
                        {v}
                      </Styled.HighlightedFieldValue>
                    ))}
                  </Styled.FieldValuesWrapper>
                </>
              )}
            </Styled.ServiceSummaryContent>
          </Card>
        )}
        <ContactCard />
      </Styled.AccountManagement>
    </Page>
  );
};

export default AccountManagement;
